let toastContainer = null;

function createToastContainer() {
	toastContainer = document.createElement("div");
	toastContainer.id = "toast-container";
	toastContainer.className = `
		fixed top-6 left-1/2 -translate-x-1/2 
		z-[9999] space-y-2 
		pointer-events-none
	`;
	document.body.appendChild(toastContainer);
}

export function showToast(type, message) {
	console.log("📣 Showing toast:", type, message);

	if (!toastContainer) createToastContainer();
	if (!message || typeof message !== "string") {
		message = "Unexpected error occurred";
	}
	const bgClass = {
		success: "bg-green-100 text-green-800 border-green-300",
		error: "bg-red-100 text-red-800 border-red-300",
		info: "bg-blue-100 text-blue-800 border-blue-300",
	}[type];

	const toast = document.createElement("div");
	toast.className = `
  flex items-start w-full max-w-sm sm:max-w-xs p-4 text-sm border rounded-lg shadow-lg
  break-words whitespace-normal leading-snug space-x-2 ${bgClass}
`;

	toast.innerHTML = `
    <div class="text-sm font-medium">${message}</div>
    <button type="button" class="ml-auto -mx-1.5 -my-1.5 text-gray-500 hover:text-gray-900 rounded-lg p-1" aria-label="Close">
      <span class="sr-only">Close</span>
      <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M4.29 4.3a1 1 0 011.42 0L10 8.6l4.3-4.3a1 1 0 011.4 1.4L11.4 10l4.3 4.3a1 1 0 01-1.4 1.4L10 11.4l-4.3 4.3a1 1 0 01-1.4-1.4L8.6 10 4.3 5.7a1 1 0 010-1.4z" clip-rule="evenodd"/>
      </svg>
    </button>`;

	toast.querySelector("button").addEventListener("click", () => toast.remove());

	setTimeout(() => {
		toast.classList.add("opacity-0", "transition-opacity", "duration-500");
		setTimeout(() => toast.remove(), 500);
	}, 6000);

	toastContainer.appendChild(toast);
}

export function showSuccess(msg) {
	showToast("success", msg);
}
export function showError(msg) {
	showToast("error", msg);
}
export function showInfo(msg) {
	showToast("info", msg);
}
